import { render, staticRenderFns } from "./PayrollIntegration.vue?vue&type=template&id=6cb547b2&scoped=true"
import script from "./PayrollIntegration.vue?vue&type=script&lang=ts"
export * from "./PayrollIntegration.vue?vue&type=script&lang=ts"
import style0 from "./PayrollIntegration.vue?vue&type=style&index=0&id=6cb547b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb547b2",
  null
  
)

export default component.exports